import React, {
    useEffect,
    useMemo,
    useState
} from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,
    ModalScrollContenido,

    BotonPrincipal,
    BotonSecundario,

    CobroFormulario,
    CobroCamposGrid,
    CobroCampo,
    CobroLabel,
    CobroInput,
    CobroSelect,
    CobroTextarea
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement(
    '#root'
);


/*
====================================
FECHA DE HOY
====================================
*/

const getFechaHoy = () => {

    const hoy =
        new Date();


    const year =
        hoy.getFullYear();


    const month =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );


    const day =
        String(
            hoy.getDate()
        ).padStart(
            2,
            '0'
        );


    return `${year}-${month}-${day}`;

};


/*
====================================
BOOLEANO
====================================
*/

const getBoolean = (
    value
) => {

    return (
        value === true ||
        value === 1 ||
        value === '1' ||
        String(value)
            .toLowerCase() ===
            'true'
    );

};


/*
====================================
NÚMERO
====================================
*/

const getNumber = (
    value
) => {

    if (
        value === null ||
        value === undefined ||
        value === ''
    ) {

        return null;

    }


    const numero =
        Number(
            String(value)
                .replace(
                    ',',
                    '.'
                )
        );


    return Number.isFinite(
        numero
    )

        ? numero

        : null;

};


/*
====================================
COMPARAR NÚMEROS
====================================
*/

const mismosNumeros = (
    a,
    b
) => {

    const numeroA =
        getNumber(
            a
        );


    const numeroB =
        getNumber(
            b
        );


    if (
        numeroA === null &&
        numeroB === null
    ) {

        return true;

    }


    if (
        numeroA === null ||
        numeroB === null
    ) {

        return false;

    }


    return (
        Math.abs(
            numeroA -
            numeroB
        ) <
        0.0001
    );

};


/*
====================================
TIENE OVERRIDES
====================================
*/

const tieneOverrides = (
    acuerdo
) => {

    if (
        !acuerdo
    ) {

        return false;

    }


    const campos = [

        'fee_tipo_override',
        'fee_valor_override',
        'fee_base_override',
        'fee_mensual_condicion_override',

        'paga_sesion_paciente_override',
        'paga_reunion_padres_override',
        'paga_reunion_colegio_override',
        'paga_reunion_profesionales_override',

        'vencimiento_tipo_override',
        'vencimiento_meses_override',
        'vencimiento_dia_override'

    ];


    return campos.some(
        (campo) =>

            acuerdo[campo] !==
                null &&

            acuerdo[campo] !==
                undefined
    );

};


/*
====================================
ACUERDO APLICABLE EN UNA FECHA
====================================
*/

const getAcuerdoAplicable = (

    acuerdos,

    idPaciente,

    fecha

) => {

    if (
        !fecha
    ) {

        return null;

    }


    return (

        (
            Array.isArray(
                acuerdos
            )

                ? acuerdos

                : []
        )
            .filter(
                (acuerdo) => {

                    if (
                        acuerdo?.activo ===
                            false
                    ) {

                        return false;

                    }


                    if (
                        String(
                            acuerdo
                                ?.id_paciente
                        ) !==
                        String(
                            idPaciente
                        )
                    ) {

                        return false;

                    }


                    const desde =
                        String(
                            acuerdo
                                ?.fecha_desde ||
                            ''
                        )
                            .substring(
                                0,
                                10
                            );


                    const hasta =

                        acuerdo
                            ?.fecha_hasta

                            ? String(
                                acuerdo
                                    .fecha_hasta
                            )
                                .substring(
                                    0,
                                    10
                                )

                            : null;


                    return (

                        desde <=
                            fecha &&

                        (
                            !hasta ||
                            hasta >=
                                fecha
                        )

                    );

                }
            )
            .sort(
                (
                    a,
                    b
                ) =>

                    String(
                        b.fecha_desde
                    )
                        .localeCompare(
                            String(
                                a.fecha_desde
                            )
                        )
            )[0] ||

        null

    );

};


/*
====================================
FECHA INICIAL
====================================
*/

const getFechaInicial = (

    acuerdos,

    idPaciente

) => {

    const hoy =
        getFechaHoy();


    const actual =
        getAcuerdoAplicable(

            acuerdos,

            idPaciente,

            hoy

        );


    if (
        actual
    ) {

        return hoy;

    }


    const lista =
        (
            Array.isArray(
                acuerdos
            )

                ? acuerdos

                : []
        )
            .filter(
                (acuerdo) =>

                    acuerdo?.activo !==
                        false &&

                    String(
                        acuerdo
                            ?.id_paciente
                    ) ===
                    String(
                        idPaciente
                    )
            )
            .sort(
                (
                    a,
                    b
                ) =>

                    String(
                        a.fecha_desde
                    )
                        .localeCompare(
                            String(
                                b.fecha_desde
                            )
                        )
            );


    const futuro =
        lista.find(
            (acuerdo) =>

                String(
                    acuerdo.fecha_desde
                )
                    .substring(
                        0,
                        10
                    ) >=
                hoy
        );


    if (
        futuro
    ) {

        return String(
            futuro.fecha_desde
        )
            .substring(
                0,
                10
            );

    }


    const ultimo =
        lista[
            lista.length -
            1
        ];


    return ultimo
        ?.fecha_desde

        ? String(
            ultimo.fecha_desde
        )
            .substring(
                0,
                10
            )

        : hoy;

};


/*
====================================
NOMBRE
====================================
*/

const getNombrePaciente = (
    paciente
) => {

    if (
        !paciente
    ) {

        return 'Paciente';

    }


    return `${paciente.apellido || ''}, ${paciente.nombre || ''}`
        .replace(
            /^,\s*/,
            ''
        )
        .trim();

};


/*
====================================
FEE GENERAL
====================================
*/

const getFeeGeneralTexto = (
    configuracion
) => {

    if (
        !configuracion
    ) {

        return 'Sin configuración';

    }


    if (
        configuracion.fee_tipo ===
            'PORCENTAJE'
    ) {

        return `${Number(
            configuracion.fee_valor ||
            0
        )}%`;

    }


    if (
        configuracion.fee_tipo ===
            'FIJO_PRESTACION'
    ) {

        return `$ ${Number(
            configuracion.fee_valor ||
            0
        ).toLocaleString(
            'es-AR'
        )} por prestación`;

    }


    if (
        configuracion.fee_tipo ===
            'FIJO_MENSUAL'
    ) {

        return `$ ${Number(
            configuracion.fee_valor ||
            0
        ).toLocaleString(
            'es-AR'
        )} mensual`;

    }


    return '—';

};


/*
====================================
MODAL
====================================
*/

const CondicionesPacienteCentroModal = ({

    isOpen,

    onClose,

    centro,

    paciente,

    acuerdos,

    onGuardar,

    guardando

}) => {


    const configuracion =
        centro
            ?.configuracion ||
        null;


    const idPaciente =
        paciente
            ?.id_paciente ||
        paciente
            ?.id ||
        null;


    /*
    ====================================
    ESTADOS
    ====================================
    */

    const [
        fechaDesde,
        setFechaDesde
    ] = useState(
        getFechaHoy()
    );


    const [
        modo,
        setModo
    ] = useState(
        'GENERAL'
    );


    const [
        feeTipo,
        setFeeTipo
    ] = useState(
        'PORCENTAJE'
    );


    const [
        feeValor,
        setFeeValor
    ] = useState(
        ''
    );


    const [
        feeBase,
        setFeeBase
    ] = useState(
        'PRESTACION'
    );


    const [
        feeMensualCondicion,
        setFeeMensualCondicion
    ] = useState(
        'MES_CON_PRESTACIONES'
    );


    const [
        pagaSesionPaciente,
        setPagaSesionPaciente
    ] = useState(
        true
    );


    const [
        pagaReunionPadres,
        setPagaReunionPadres
    ] = useState(
        false
    );


    const [
        pagaReunionColegio,
        setPagaReunionColegio
    ] = useState(
        false
    );


    const [
        pagaReunionProfesionales,
        setPagaReunionProfesionales
    ] = useState(
        false
    );


    const [
        vencimientoTipo,
        setVencimientoTipo
    ] = useState(
        'FIN_MES'
    );


    const [
        vencimientoMeses,
        setVencimientoMeses
    ] = useState(
        '1'
    );


    const [
        vencimientoDia,
        setVencimientoDia
    ] = useState(
        ''
    );


    const [
        observacion,
        setObservacion
    ] = useState(
        ''
    );


    const [
        errorFormulario,
        setErrorFormulario
    ] = useState(
        ''
    );


    /*
    ====================================
    CARGAR VALORES DE UNA FECHA
    ====================================
    */

    const cargarValores =
        (
            fecha
        ) => {

            const acuerdo =
                getAcuerdoAplicable(

                    acuerdos,

                    idPaciente,

                    fecha

                );


            const particular =
                tieneOverrides(
                    acuerdo
                );


            setModo(
                particular
                    ? 'PARTICULAR'
                    : 'GENERAL'
            );


            setFeeTipo(

                acuerdo
                    ?.fee_tipo_override ??

                configuracion
                    ?.fee_tipo ??

                'PORCENTAJE'

            );


            setFeeValor(
                String(

                    acuerdo
                        ?.fee_valor_override ??

                    configuracion
                        ?.fee_valor ??

                    ''

                )
            );


            setFeeBase(

                acuerdo
                    ?.fee_base_override ??

                configuracion
                    ?.fee_base ??

                'PRESTACION'

            );


            setFeeMensualCondicion(

                acuerdo
                    ?.fee_mensual_condicion_override ??

                configuracion
                    ?.fee_mensual_condicion ??

                'MES_CON_PRESTACIONES'

            );


            setPagaSesionPaciente(

                acuerdo
                    ?.paga_sesion_paciente_override !==
                        null &&
                acuerdo
                    ?.paga_sesion_paciente_override !==
                        undefined

                    ? getBoolean(
                        acuerdo
                            .paga_sesion_paciente_override
                    )

                    : getBoolean(
                        configuracion
                            ?.paga_sesion_paciente
                    )

            );


            setPagaReunionPadres(

                acuerdo
                    ?.paga_reunion_padres_override !==
                        null &&
                acuerdo
                    ?.paga_reunion_padres_override !==
                        undefined

                    ? getBoolean(
                        acuerdo
                            .paga_reunion_padres_override
                    )

                    : getBoolean(
                        configuracion
                            ?.paga_reunion_padres
                    )

            );


            setPagaReunionColegio(

                acuerdo
                    ?.paga_reunion_colegio_override !==
                        null &&
                acuerdo
                    ?.paga_reunion_colegio_override !==
                        undefined

                    ? getBoolean(
                        acuerdo
                            .paga_reunion_colegio_override
                    )

                    : getBoolean(
                        configuracion
                            ?.paga_reunion_colegio
                    )

            );


            setPagaReunionProfesionales(

                acuerdo
                    ?.paga_reunion_profesionales_override !==
                        null &&
                acuerdo
                    ?.paga_reunion_profesionales_override !==
                        undefined

                    ? getBoolean(
                        acuerdo
                            .paga_reunion_profesionales_override
                    )

                    : getBoolean(
                        configuracion
                            ?.paga_reunion_profesionales
                    )

            );


            setVencimientoTipo(

                acuerdo
                    ?.vencimiento_tipo_override ??

                configuracion
                    ?.vencimiento_tipo ??

                'FIN_MES'

            );


            setVencimientoMeses(
                String(

                    acuerdo
                        ?.vencimiento_meses_override ??

                    configuracion
                        ?.vencimiento_meses ??

                    1

                )
            );


            setVencimientoDia(

                acuerdo
                    ?.vencimiento_dia_override ??

                configuracion
                    ?.vencimiento_dia ??

                ''

            );


            setObservacion(
                acuerdo
                    ?.observacion ||
                ''
            );

        };


    /*
    ====================================
    ABRIR
    ====================================
    */

    useEffect(() => {

        if (
            !isOpen ||
            !idPaciente
        ) {

            return;

        }


        const fechaInicial =
            getFechaInicial(

                acuerdos,

                idPaciente

            );


        setFechaDesde(
            fechaInicial
        );


        setErrorFormulario(
            ''
        );


        cargarValores(
            fechaInicial
        );

    }, [
        isOpen,
        idPaciente,
        centro,
        acuerdos
    ]);


    /*
    ====================================
    ACUERDO EN LA FECHA ELEGIDA
    ====================================
    */

    const acuerdoAplicable =
        useMemo(() => {

            return getAcuerdoAplicable(

                acuerdos,

                idPaciente,

                fechaDesde

            );

        }, [
            acuerdos,
            idPaciente,
            fechaDesde
        ]);


    /*
    ====================================
    CAMBIAR FECHA
    ====================================
    */

    const handleCambiarFecha = (
        nuevaFecha
    ) => {

        setFechaDesde(
            nuevaFecha
        );


        setErrorFormulario(
            ''
        );


        if (
            nuevaFecha
        ) {

            cargarValores(
                nuevaFecha
            );

        }

    };


    /*
    ====================================
    GUARDAR
    ====================================
    */

    const handleGuardar =
        async () => {

            setErrorFormulario(
                ''
            );


            if (
                guardando
            ) {

                return;

            }


            if (
                !centro?.id ||
                !idPaciente
            ) {

                setErrorFormulario(
                    'No se pudo identificar el centro o el paciente.'
                );

                return;

            }


            if (
                !fechaDesde
            ) {

                setErrorFormulario(
                    'Indicá desde qué fecha se aplican las condiciones.'
                );

                return;

            }


            if (
                !acuerdoAplicable
            ) {

                setErrorFormulario(
                    'El paciente no tiene una vinculación vigente con este centro en la fecha seleccionada.'
                );

                return;

            }


            if (
                typeof onGuardar !==
                    'function'
            ) {

                return;

            }


            /*
            ====================================
            VOLVER A CONDICIONES GENERALES
            ====================================
            */

            if (
                modo ===
                    'GENERAL'
            ) {

                const resultado =
                    await onGuardar({

                        centro_id:
                            centro.id,

                        id_paciente:
                            idPaciente,

                        fecha_desde:
                            fechaDesde,

                        fee_tipo_override:
                            null,

                        fee_valor_override:
                            null,

                        fee_base_override:
                            null,

                        fee_mensual_condicion_override:
                            null,

                        paga_sesion_paciente_override:
                            null,

                        paga_reunion_padres_override:
                            null,

                        paga_reunion_colegio_override:
                            null,

                        paga_reunion_profesionales_override:
                            null,

                        vencimiento_tipo_override:
                            null,

                        vencimiento_meses_override:
                            null,

                        vencimiento_dia_override:
                            null,

                        observacion:
                            null

                    });


                if (
                    resultado?.msg
                ) {

                    setErrorFormulario(
                        resultado.msg
                    );

                }


                return;

            }


            /*
            ====================================
            VALIDAR PARTICULAR
            ====================================
            */

            const feeValorNumero =
                getNumber(
                    feeValor
                );


            if (
                feeValorNumero ===
                    null ||
                feeValorNumero <=
                    0
            ) {

                setErrorFormulario(
                    'El valor del fee debe ser mayor a 0.'
                );

                return;

            }


            if (
                feeTipo ===
                    'PORCENTAJE' &&
                feeValorNumero >
                    100
            ) {

                setErrorFormulario(
                    'El porcentaje no puede superar 100%.'
                );

                return;

            }


            if (
                feeTipo ===
                    'FIJO_MENSUAL' &&
                !feeMensualCondicion
            ) {

                setErrorFormulario(
                    'Seleccioná la condición del fee mensual.'
                );

                return;

            }


            const mesesNumero =
                getNumber(
                    vencimientoMeses
                );


            if (
                vencimientoTipo !==
                    'INMEDIATO' &&
                (
                    mesesNumero ===
                        null ||
                    mesesNumero <
                        0 ||
                    !Number.isInteger(
                        mesesNumero
                    )
                )
            ) {

                setErrorFormulario(
                    'El diferimiento en meses debe ser un número entero igual o mayor a 0.'
                );

                return;

            }


            const diaNumero =
                getNumber(
                    vencimientoDia
                );


            if (
                vencimientoTipo ===
                    'DIA_MES' &&
                (
                    diaNumero ===
                        null ||
                    diaNumero <
                        1 ||
                    diaNumero >
                        31 ||
                    !Number.isInteger(
                        diaNumero
                    )
                )
            ) {

                setErrorFormulario(
                    'El día de vencimiento debe estar entre 1 y 31.'
                );

                return;

            }


            /*
            ====================================
            SOLO GUARDAMOS DIFERENCIAS
            ====================================

            Si un valor coincide con la
            configuración general, enviamos null.

            Así ese campo continúa heredándose
            del centro.
            ====================================
            */

            const datos = {

                centro_id:
                    centro.id,

                id_paciente:
                    idPaciente,

                fecha_desde:
                    fechaDesde,


                fee_tipo_override:

                    feeTipo ===
                        configuracion
                            ?.fee_tipo

                        ? null

                        : feeTipo,


                fee_valor_override:

                    mismosNumeros(
                        feeValorNumero,
                        configuracion
                            ?.fee_valor
                    )

                        ? null

                        : feeValorNumero,


                fee_base_override:

                    feeBase ===
                        configuracion
                            ?.fee_base

                        ? null

                        : feeBase,


                fee_mensual_condicion_override:

                    feeTipo !==
                        'FIJO_MENSUAL'

                        ? null

                        : (
                            feeMensualCondicion ===
                                configuracion
                                    ?.fee_mensual_condicion

                                ? null

                                : feeMensualCondicion
                        ),


                paga_sesion_paciente_override:

                    pagaSesionPaciente ===
                        getBoolean(
                            configuracion
                                ?.paga_sesion_paciente
                        )

                        ? null

                        : pagaSesionPaciente,


                paga_reunion_padres_override:

                    pagaReunionPadres ===
                        getBoolean(
                            configuracion
                                ?.paga_reunion_padres
                        )

                        ? null

                        : pagaReunionPadres,


                paga_reunion_colegio_override:

                    pagaReunionColegio ===
                        getBoolean(
                            configuracion
                                ?.paga_reunion_colegio
                        )

                        ? null

                        : pagaReunionColegio,


                paga_reunion_profesionales_override:

                    pagaReunionProfesionales ===
                        getBoolean(
                            configuracion
                                ?.paga_reunion_profesionales
                        )

                        ? null

                        : pagaReunionProfesionales,


                vencimiento_tipo_override:

                    vencimientoTipo ===
                        configuracion
                            ?.vencimiento_tipo

                        ? null

                        : vencimientoTipo,


                vencimiento_meses_override:

                    vencimientoTipo ===
                        'INMEDIATO'

                        ? null

                        : (
                            mismosNumeros(
                                mesesNumero,
                                configuracion
                                    ?.vencimiento_meses
                            )

                                ? null

                                : mesesNumero
                        ),


                vencimiento_dia_override:

                    vencimientoTipo !==
                        'DIA_MES'

                        ? null

                        : (
                            mismosNumeros(
                                diaNumero,
                                configuracion
                                    ?.vencimiento_dia
                            )

                                ? null

                                : diaNumero
                        ),


                observacion:

                    observacion
                        .trim() ||

                    null

            };


            const hayOverride = [

                datos
                    .fee_tipo_override,

                datos
                    .fee_valor_override,

                datos
                    .fee_base_override,

                datos
                    .fee_mensual_condicion_override,

                datos
                    .paga_sesion_paciente_override,

                datos
                    .paga_reunion_padres_override,

                datos
                    .paga_reunion_colegio_override,

                datos
                    .paga_reunion_profesionales_override,

                datos
                    .vencimiento_tipo_override,

                datos
                    .vencimiento_meses_override,

                datos
                    .vencimiento_dia_override

            ].some(
                (valor) =>

                    valor !==
                        null &&

                    valor !==
                        undefined
            );


            if (
                !hayOverride
            ) {

                setErrorFormulario(
                    'Las condiciones particulares son iguales a las generales. Podés seleccionar “Condiciones generales”.'
                );

                return;

            }


            const resultado =
                await onGuardar(
                    datos
                );


            if (
                resultado?.msg
            ) {

                setErrorFormulario(
                    resultado.msg
                );

            }

        };


    /*
    ====================================
    CERRAR
    ====================================
    */

    const handleCerrar = () => {

        if (
            guardando
        ) {

            return;

        }


        onClose();

    };


    return (

        <Modal

            isOpen={
                isOpen
            }

            onRequestClose={
                handleCerrar
            }

            shouldCloseOnOverlayClick={
                !guardando
            }

            shouldCloseOnEsc={
                !guardando
            }

            style={{

                overlay: {

                    zIndex:
                        2000,

                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    padding:
                        '1rem'

                },

                content: {

                    position:
                        'relative',

                    inset:
                        'auto',

                    border:
                        'none',

                    background:
                        'transparent',

                    padding:
                        0,

                    width:
                        '100%',

                    maxWidth:
                        '760px',

                    maxHeight:
                        '92vh',

                    overflow:
                        'hidden',

                    boxSizing:
                        'border-box'

                }

            }}
        >

            <ModalEconomiaContenido>


                <ModalEconomiaCabecera>

                    <div>

                        <ModalEconomiaTitulo>
                            Condiciones del paciente
                        </ModalEconomiaTitulo>


                        <ModalEconomiaSubtitulo>

                            {
                                getNombrePaciente(
                                    paciente
                                )
                            }

                            {' · '}

                            {
                                centro
                                    ?.nombre ||
                                'Centro'
                            }

                        </ModalEconomiaSubtitulo>

                    </div>


                    <BotonCerrarModal

                        type="button"

                        onClick={
                            handleCerrar
                        }

                        disabled={
                            guardando
                        }
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                <ModalScrollContenido>

                    <CobroFormulario>


                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Vigencia
                            </ModalSeccionTitulo>


                            <CobroCamposGrid>

                                <CobroCampo>

                                    <CobroLabel>
                                        Aplicar desde
                                    </CobroLabel>


                                    <CobroInput

                                        type="date"

                                        min={
                                            getFechaHoy()
                                        }

                                        value={
                                            fechaDesde
                                        }

                                        onChange={(e) =>
                                            handleCambiarFecha(
                                                e.target.value
                                            )
                                        }

                                        disabled={
                                            guardando
                                        }
                                    />

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        Tipo de condición
                                    </CobroLabel>


                                    <CobroSelect

                                        value={
                                            modo
                                        }

                                        onChange={(e) => {

                                            setModo(
                                                e.target.value
                                            );

                                            setErrorFormulario(
                                                ''
                                            );

                                        }}

                                        disabled={
                                            guardando
                                        }
                                    >

                                        <option
                                            value="GENERAL"
                                        >
                                            Condiciones generales
                                        </option>


                                        <option
                                            value="PARTICULAR"
                                        >
                                            Condiciones particulares
                                        </option>

                                    </CobroSelect>

                                </CobroCampo>

                            </CobroCamposGrid>


                            <div
                                style={{

                                    marginTop:
                                        '0.8rem',

                                    padding:
                                        '0.75rem 0.85rem',

                                    borderRadius:
                                        '8px',

                                    backgroundColor:
                                        '#F5FAFA',

                                    fontSize:
                                        '0.76rem',

                                    lineHeight:
                                        1.5,

                                    color:
                                        '#526363'

                                }}
                            >

                                <strong>
                                    Condición general actual:
                                </strong>

                                {' '}

                                {
                                    getFeeGeneralTexto(
                                        configuracion
                                    )
                                }

                                {' · '}

                                Base:

                                {' '}

                                {
                                    configuracion
                                        ?.fee_base ===
                                        'COBRO'

                                        ? 'sobre cobro'

                                        : 'sobre prestación'
                                }

                            </div>

                        </ModalSeccion>


                        {
                            modo ===
                                'PARTICULAR'

                                ? (

                                    <>


                                        <ModalSeccion>

                                            <ModalSeccionTitulo>
                                                Honorario
                                            </ModalSeccionTitulo>


                                            <CobroCamposGrid>

                                                <CobroCampo>

                                                    <CobroLabel>
                                                        Tipo
                                                    </CobroLabel>


                                                    <CobroSelect

                                                        value={
                                                            feeTipo
                                                        }

                                                        onChange={(e) =>
                                                            setFeeTipo(
                                                                e.target.value
                                                            )
                                                        }

                                                        disabled={
                                                            guardando
                                                        }
                                                    >

                                                        <option value="PORCENTAJE">
                                                            Porcentaje
                                                        </option>

                                                        <option value="FIJO_PRESTACION">
                                                            Importe fijo por prestación
                                                        </option>

                                                        <option value="FIJO_MENSUAL">
                                                            Importe fijo mensual
                                                        </option>

                                                    </CobroSelect>

                                                </CobroCampo>


                                                <CobroCampo>

                                                    <CobroLabel>

                                                        {
                                                            feeTipo ===
                                                                'PORCENTAJE'

                                                                ? 'Porcentaje'

                                                                : 'Importe'
                                                        }

                                                    </CobroLabel>


                                                    <CobroInput

                                                        type="text"

                                                        inputMode="decimal"

                                                        value={
                                                            feeValor
                                                        }

                                                        onChange={(e) => {

                                                            const value =
                                                                e.target.value;


                                                            if (
                                                                value ===
                                                                    '' ||
                                                                /^\d*[.,]?\d{0,2}$/
                                                                    .test(
                                                                        value
                                                                    )
                                                            ) {

                                                                setFeeValor(
                                                                    value
                                                                );

                                                            }

                                                        }}

                                                        disabled={
                                                            guardando
                                                        }
                                                    />

                                                </CobroCampo>


                                                <CobroCampo>

                                                    <CobroLabel>
                                                        Base
                                                    </CobroLabel>


                                                    <CobroSelect

                                                        value={
                                                            feeBase
                                                        }

                                                        onChange={(e) =>
                                                            setFeeBase(
                                                                e.target.value
                                                            )
                                                        }

                                                        disabled={
                                                            guardando
                                                        }
                                                    >

                                                        <option value="PRESTACION">
                                                            Al realizar la prestación
                                                        </option>

                                                        <option value="COBRO">
                                                            Al cobrar al paciente
                                                        </option>

                                                    </CobroSelect>

                                                </CobroCampo>


                                                {
                                                    feeTipo ===
                                                        'FIJO_MENSUAL'

                                                        ? (

                                                            <CobroCampo>

                                                                <CobroLabel>
                                                                    Condición mensual
                                                                </CobroLabel>


                                                                <CobroSelect

                                                                    value={
                                                                        feeMensualCondicion
                                                                    }

                                                                    onChange={(e) =>
                                                                        setFeeMensualCondicion(
                                                                            e.target.value
                                                                        )
                                                                    }

                                                                    disabled={
                                                                        guardando
                                                                    }
                                                                >

                                                                    <option value="MES_CON_PRESTACIONES">
                                                                        Mes con prestaciones
                                                                    </option>

                                                                    <option value="MES_VINCULADO">
                                                                        Todo mes vinculado
                                                                    </option>

                                                                    <option value="MES_CON_COBROS">
                                                                        Mes con cobros
                                                                    </option>

                                                                </CobroSelect>

                                                            </CobroCampo>

                                                        )

                                                        : null
                                                }

                                            </CobroCamposGrid>

                                        </ModalSeccion>


                                        <ModalSeccion>

                                            <ModalSeccionTitulo>
                                                Prestaciones que paga el centro
                                            </ModalSeccionTitulo>


                                            <div
                                                style={{

                                                    display:
                                                        'grid',

                                                    gridTemplateColumns:
                                                        'repeat(2, minmax(0, 1fr))',

                                                    gap:
                                                        '0.6rem'

                                                }}
                                            >

                                                <label>
                                                    <input

                                                        type="checkbox"

                                                        checked={
                                                            pagaSesionPaciente
                                                        }

                                                        onChange={(e) =>
                                                            setPagaSesionPaciente(
                                                                e.target.checked
                                                            )
                                                        }
                                                    />

                                                    {' '}

                                                    Sesión con paciente
                                                </label>


                                                <label>
                                                    <input

                                                        type="checkbox"

                                                        checked={
                                                            pagaReunionPadres
                                                        }

                                                        onChange={(e) =>
                                                            setPagaReunionPadres(
                                                                e.target.checked
                                                            )
                                                        }
                                                    />

                                                    {' '}

                                                    Reunión con padres
                                                </label>


                                                <label>
                                                    <input

                                                        type="checkbox"

                                                        checked={
                                                            pagaReunionColegio
                                                        }

                                                        onChange={(e) =>
                                                            setPagaReunionColegio(
                                                                e.target.checked
                                                            )
                                                        }
                                                    />

                                                    {' '}

                                                    Reunión con colegio
                                                </label>


                                                <label>
                                                    <input

                                                        type="checkbox"

                                                        checked={
                                                            pagaReunionProfesionales
                                                        }

                                                        onChange={(e) =>
                                                            setPagaReunionProfesionales(
                                                                e.target.checked
                                                            )
                                                        }
                                                    />

                                                    {' '}

                                                    Reunión con profesionales
                                                </label>

                                            </div>

                                        </ModalSeccion>


                                        <ModalSeccion>

                                            <ModalSeccionTitulo>
                                                Vencimiento
                                            </ModalSeccionTitulo>


                                            <CobroCamposGrid>

                                                <CobroCampo>

                                                    <CobroLabel>
                                                        Tipo
                                                    </CobroLabel>


                                                    <CobroSelect

                                                        value={
                                                            vencimientoTipo
                                                        }

                                                        onChange={(e) =>
                                                            setVencimientoTipo(
                                                                e.target.value
                                                            )
                                                        }
                                                    >

                                                        <option value="INMEDIATO">
                                                            Inmediato
                                                        </option>

                                                        <option value="FIN_MES">
                                                            Fin de mes
                                                        </option>

                                                        <option value="DIA_MES">
                                                            Día específico
                                                        </option>

                                                    </CobroSelect>

                                                </CobroCampo>


                                                {
                                                    vencimientoTipo !==
                                                        'INMEDIATO'

                                                        ? (

                                                            <CobroCampo>

                                                                <CobroLabel>
                                                                    Meses después
                                                                </CobroLabel>


                                                                <CobroInput

                                                                    type="number"

                                                                    min="0"

                                                                    step="1"

                                                                    value={
                                                                        vencimientoMeses
                                                                    }

                                                                    onChange={(e) =>
                                                                        setVencimientoMeses(
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />

                                                            </CobroCampo>

                                                        )

                                                        : null
                                                }


                                                {
                                                    vencimientoTipo ===
                                                        'DIA_MES'

                                                        ? (

                                                            <CobroCampo>

                                                                <CobroLabel>
                                                                    Día del mes
                                                                </CobroLabel>


                                                                <CobroInput

                                                                    type="number"

                                                                    min="1"

                                                                    max="31"

                                                                    step="1"

                                                                    value={
                                                                        vencimientoDia
                                                                    }

                                                                    onChange={(e) =>
                                                                        setVencimientoDia(
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />

                                                            </CobroCampo>

                                                        )

                                                        : null
                                                }

                                            </CobroCamposGrid>


                                            <CobroCampo
                                                style={{
                                                    marginTop:
                                                        '0.7rem'
                                                }}
                                            >

                                                <CobroLabel>
                                                    Observación
                                                </CobroLabel>


                                                <CobroTextarea

                                                    value={
                                                        observacion
                                                    }

                                                    onChange={(e) =>
                                                        setObservacion(
                                                            e.target.value
                                                        )
                                                    }

                                                    maxLength={
                                                        500
                                                    }

                                                    placeholder="Opcional"
                                                />

                                            </CobroCampo>

                                        </ModalSeccion>

                                    </>

                                )

                                : (

                                    <ModalSeccion>

                                        <div
                                            style={{

                                                fontSize:
                                                    '0.78rem',

                                                lineHeight:
                                                    1.55,

                                                color:
                                                    '#526363'

                                            }}
                                        >

                                            Desde la fecha indicada,
                                            este paciente volverá a
                                            heredar automáticamente las
                                            condiciones generales del
                                            centro.

                                        </div>

                                    </ModalSeccion>

                                )
                        }


                        {
                            errorFormulario

                                ? (

                                    <div
                                        style={{

                                            color:
                                                '#C94B55',

                                            fontSize:
                                                '0.78rem',

                                            fontWeight:
                                                600,

                                            marginTop:
                                                '0.8rem'

                                        }}
                                    >

                                        {
                                            errorFormulario
                                        }

                                    </div>

                                )

                                : null
                        }


                        <ModalAcciones>

                            <BotonSecundario

                                type="button"

                                onClick={
                                    handleCerrar
                                }

                                disabled={
                                    guardando
                                }
                            >
                                Cancelar
                            </BotonSecundario>


                            <BotonPrincipal

                                type="button"

                                onClick={
                                    handleGuardar
                                }

                                disabled={
                                    guardando
                                }
                            >

                                {
                                    guardando

                                        ? 'Guardando...'

                                        : 'Guardar condiciones'
                                }

                            </BotonPrincipal>

                        </ModalAcciones>

                    </CobroFormulario>

                </ModalScrollContenido>

            </ModalEconomiaContenido>

        </Modal>

    );

};


export default CondicionesPacienteCentroModal;